import {gsap} from "gsap";
import EmitEvent, {SMOOTH_DISABLED, SMOOTH_ENABLED} from "../../../libs/emit-event";
import AnimationFade from "../../animation/fade/fade";
import AnimationChars from "../../animation/chars/chars";

export class HeaderMenu {
    constructor({el, onClose, headerLogo}) {
        this.DOM = {el, headerLogo};
        this.DOM.inner = this.DOM.el.querySelector('.js-header_menu_inner');

        this.styles = {
            clipPath: 100
        };

        this.elMenuActive = null;
        this.onClose = onClose;
        this.init();
        this.creatDom();
        this.bindEvent();
    }

    init() {

        this.menuItemAnimation = [];
        this.DOM.el.querySelectorAll('.menu-item').forEach(item => {
            this.menuItemAnimation.push(new AnimationChars(item.querySelector('a'), {
                type: '2d', _to: {
                    duration: .8, onComplete: () => {
                        item.dispatchEvent(new CustomEvent('animationIn'));
                    }
                }
            }));
        });
        this.animations = {
            social: new AnimationFade(this.DOM.el.querySelector('.js-header_menu_social')),
            address: new AnimationFade(this.DOM.el.querySelector('.js-header_menu_address')),
            copyright: new AnimationFade(this.DOM.el.querySelector('.js-header_menu_desc')),
            copyright_2: new AnimationFade(this.DOM.el.querySelector('.js-header_menu_desc_clone'))
        }
        this.innerClip(this.styles.clipPath);
    }

    creatDom() {
        this.DOM.backDrop = document.createElement('span');
        this.DOM.backDrop.classList.add('header_backDrop');
        this.DOM.el.append(this.DOM.backDrop);
        gsap.set(this.DOM.backDrop, {opacity: 0});
    }

    innerClip(value) {
        this.DOM.inner.style.clipPath = `inset(0 0 ${value}% 0)`;
        this.DOM.inner.style.webkitClipPath = `inset(0 0 ${value}% 0)`;
    }

    openMenu() {
        this.DOM.el.style.pointerEvents = `auto`;
        EmitEvent.emit(SMOOTH_DISABLED);
        gsap.to(this.DOM.backDrop, {opacity: 1, ease: 'power3.out', duration: .5});
        gsap.to(this.styles, {
            clipPath: 0, ease: 'power3.inOut', duration: .8, onUpdate: () => {
                this.innerClip(this.styles.clipPath);
            }
        });

        let delay = .3;
        this.menuItemAnimation.forEach(ani => {
            ani.animationIn(delay);
            delay += .045;
        });

        delay = .4;
        this.animations.social.animationIn((delay += .1));
        this.animations.address.animationIn((delay += .1));
        this.animations.copyright.animationIn((delay += .1));
        this.animations.copyright_2.animationIn((delay += .1));

        if (!this.DOM.headerLogo.classList.contains('is-show')) {
            gsap.killTweensOf(this.DOM.headerLogo);
            gsap.fromTo(this.DOM.headerLogo, {visibility: 'visible'}, {
                opacity: 1,
                duration: .6,
                delay: .2,
                ease: 'power3.out'
            });
        }
    }

    closeMenu() {
        this.DOM.el.style.pointerEvents = `none`;
        EmitEvent.emit(SMOOTH_ENABLED);
        gsap.to(this.styles, {
            clipPath: 100, ease: 'power3.inOut', duration: .8, onUpdate: () => {
                this.innerClip(this.styles.clipPath);
            }
        });
        gsap.to(this.DOM.backDrop, {opacity: 0, ease: 'power3.out', duration: .55, delay: .25});

        if (!this.DOM.headerLogo.classList.contains('is-show')) {
            gsap.killTweensOf(this.DOM.headerLogo);
            gsap.to(this.DOM.headerLogo, {
                opacity: 0, duration: .6, delay: .2, ease: 'power3.out', onComplete: () => {
                    this.DOM.headerLogo.style = {};
                }
            });
        }
    }

    bindEvent() {
        this.DOM.backDrop.addEventListener('click', () => {
            this.onClose();
        });
    }
}